import S from 's-js';
export const AsyncRouter = (loc, seed, routes) => {
    const 
    // factory returned by the route's Promise
    factory = S.data(seed), 
    // call the factory to get the result
    result = S(() => factory()());
    // keep track of the last routing, match, in case Promises complete out of order
    let lastMatch = null;
    S(() => {
        const _loc = loc();
        for (const route of routes) {
            const match = route[0].exec(_loc);
            if (match) {
                route[1](lastMatch = match)
                    .then(result => {
                    // if we're still the current route, load our view
                    if (match === lastMatch) {
                        factory(result);
                    }
                });
                return;
            }
        }
        console.warn(`No route for ${_loc}`);
    });
    return result;
};
